import joi from '@hapi/joi';

const validateSchema = (item, schema) => {
  let errors = {};

  const validationResult = schema.validate(item, { abortEarly: false, allowUnknown: true });

  if (validationResult.error) {
    const pathDetails = validationResult.error.details.map((detail) => detail.path).join(',');
    const message = validationResult.error.details.map((detail) => detail.message).join(',');
    validationResult.error.details.forEach((detail) => {
      errors[detail.path] = detail.message;
    });
  } else {
    errors = null;
  }

  return { errors, value: validationResult.value };
};

// call when adding a P3 Items to VIRM
// P3 items do not include cost and countryOfOrigin or cooler
export const validateShortItem = (item) => {
  const schema = joi.object({
    description: joi.string().optional().allow(null),
    hi: joi.number().integer().required(),
    ti: joi.number().integer().required(),
    location: joi.string().required(),
    gtin: joi.number().integer().optional().allow(null),
    upc: joi.number().integer().optional().allow(null),
    plu: joi.number().integer().optional().allow(null),
    countryOfOrigin: joi.string().optional().allow(null).default(''),
    modifiedBy: joi.string().required(),
    createdBy: joi.string().required(),
  });

  return validateSchema(item, schema);
};

// call when editing an item already added to VIRM
const validateVirmItem = (item) => {
  const schema = joi.object({
    description: joi.string().required(),
    hi: joi.number().integer().required().min(0),
    ti: joi.number().integer().required().min(0),
    cost: joi.number().precision(2).required().min(.01),
    deliveredCost: joi.number().precision(2).optional().allow(null).allow('').min(.01),
    countryOfOrigin: joi.string().required(),
    location: joi.string().required(),
    gtin: joi.number().integer().optional().allow(null).allow(''),
    upc: joi.number().integer().optional().allow(null).allow(''),
    plu: joi.number().integer().optional().allow(null).allow(''),
    modifiedBy: joi.string().required(),
  });

  return validateSchema(item, schema);
};

const validatePremium = (premium) => {
  const schema = joi.object({
    value: joi.number().precision(2).required().min(0.01),
    unitType: joi.string().required(),
    description: joi.string().required(),
  });

  return validateSchema(premium, schema);
};

const validatePremiumItem = (item) => {
  const schema = joi.object({
    countryOfOrigin: joi.string().required(),
  });

  return validateSchema(item, schema);
};

const validateBurdenItem = (item) => {
  const schema = joi.object({
    description: joi.string().required(),
    cost: joi.number().precision(2).required().min(.01),
    unitType: joi.string().required(),
    modifiedBy: joi.string().required(),
  });

  return validateSchema(item, schema);
}

export const validateVirmItemWithConstraints = (item, locations, countryOfOrigins, coolers) => {
  const unitTypeOptions = ["CTN", "WT"]
  const schema = joi.object({
    description: joi.string().required(),
    hi: joi.number().integer().required().min(0),
    ti: joi.number().integer().required().min(0),
    cost: joi.number().precision(2).required().min(.01),
    deliveredCost: joi.number().precision(2).optional().allow(null).min(.00),
    unitType: joi.string().allow('').allow(null).valid(...unitTypeOptions).messages({
      'any.only': 'This is not a valid unit type.'
    }),
    countryOfOrigin: joi.string().required().valid(...countryOfOrigins).messages({ 
      'any.only': 'This is not a valid country of origin.'
    }),
    location: joi.string().required().valid(...locations).messages({ 
      'any.only': 'This is not a valid location.'
    }),
    gtin: joi.number().integer().optional().allow(null),
    upc: joi.number().integer().optional().allow(null),
    plu: joi.number().integer().optional().allow(null),
    cooler: joi.string().allow('').allow(null).valid(...coolers).messages({ 
      'any.only': 'This is not a valid cooler.'
    }),
    modifiedBy: joi.string().required(),
  });

  return validateSchema(item, schema);
};

export default validateVirmItem;
export { validatePremium, validateBurdenItem, validatePremiumItem };
